import React, { Component } from 'react';
import PropTypes from 'prop-types';
import NotificationSystem from 'react-notification-system';
import dateFormat from 'dateformat';
import Select from 'react-select';

import Footer from '../../../Components/Footer/Footer';
import Auth from '../../Authentication/Auth';
import Api from '../../../Services/Api';

// import CustomerOrdersSummary from './CustomerOrdersSummary';
// import CustomerOrdersList from './CustomerOrdersList';

class CustomerOrdersSelectionPage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      tailNumber: '',
    };

    this.onChange = this.onChange.bind(this);
    this.onClick = this.onClick.bind(this);
  }

  onChange(e) {
    return this.setState({ tailNumber: e.target.value });
  }

  onClick() {
    this.props.history.push(`/reports/customer/${encodeURI(this.state.tailNumber.trim())}`);
  }

  render() {
    return (
      <div className="app">
        <NotificationSystem ref={(node) => { this.notificationSystem = node; }} />
        <main className="page-content">
          <div className="reports-logo">
            <img alt="logo" src="https://pictures.dealer.com/t/tomwoodaviation/1142/45644ba64046387201eb9fdee519ecec.jpg" />
          </div>
          <div className="orders-page-header">
            <h1>Customer Orders Report</h1>
          </div>
          <section className="order-group">
            <div>Enter Tail Number</div>
            <input value={this.state.tailNumber} onChange={this.onChange} placeholder="Tail Number" />
            <button className="btn btn-medium btn-primary" onClick={this.onClick}>Submit</button>
          </section>
          <Footer />
        </main>
      </div>
    );
  }
}


export default CustomerOrdersSelectionPage;




// WEBPACK FOOTER //
// ./src/Containers/Reports/CustomerOrders/CustomerOrdersSelectionPage.js